import React, { ChangeEvent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Tooltip } from 'antd'
import KnowledgeSection from './KnowledgeSection'
import ChatPreviewPanel from './components/ChatPreviewPanel'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { UpdateApplication } from '../../components/bots/manageBot/CustomisationModal/UpdateApplication'
import { GET_ALL_APPLICATIONS } from '../../graphql/query'
import { useQuery } from '@apollo/client'

interface NavItemProps {
  active?: boolean
}

interface ButtonProps {
  primary?: boolean
}

interface ContainerProps {
  hasPreview?: boolean
}

type Section = 'instructions' | 'knowledge'

const AiSeletectedBot = () => {
  const [activeSection, setActiveSection] = useState<Section>('knowledge')
  const [Directive, setDirective] = useState('')
  const [Greeting, setGreeting] = useState('')
  const [greetingType, setGreetingType] = useState('static')
  const [aiModel, setAiModel] = useState('gpt-3.5-turbo')
  const [inputJson, setInputJson] = useState<any>([])
  const [id, setId] = useState<any>('')
  const [isLoading, setIsLoading] = useState(false)
  const { uuid } = useParams()
  const [getInformation, setGetInformation] = useState<any>([])
  const { error, loading, data } = useQuery(GET_ALL_APPLICATIONS, {
    variables: {
      input: {
        appIDString: localStorage.getItem('agenticId')
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Bot-Builder'
      }
    }
  })
  const [updateApplicationInput] = UpdateApplication(localStorage.getItem('agenticId') as string)
  const deployementEnvironment = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT as string
  const navigate = useNavigate()
  // Refactored previewUrl
  let environmentSuffix

  if (deployementEnvironment === 'prod') {
    environmentSuffix = 'live'
  } else {
    environmentSuffix = `live-${deployementEnvironment}`
  }

  const previewUrl = `https://${environmentSuffix}.botgo.io/?appId=${localStorage.getItem(
    'agenticId'
  )}`
  const handleSave = async () => {
    setIsLoading(true)
    const payload = new URLSearchParams()
    payload.append('instruction', Directive)
    payload.append('greeting_type', greetingType.toLowerCase())
    payload.append('model', aiModel)
    payload.append('greeting', Greeting)

    try {
      const response = await fetch(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/ai-chatbots/basic_instructions/${uuid}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${localStorage.getItem('auth-token')}`
          },
          body: payload.toString()
        }
      )

      const data = await response.json()

      if (response.ok) {
        const updatedInputJson = {
          ...inputJson,
          message: data?.greeting
        }

        setInputJson(updatedInputJson) // Still update state

        const updateApplicationRes = await updateApplicationInput({
          variables: {
            input: {
              applicationId: Number(id),
              intentId: 1,
              intentJson: updatedInputJson,
              previousIntentId: null
            }
          }
        })

        if (
          updateApplicationRes.data.updateApplicationInput.status >= 200 &&
          updateApplicationRes.data.updateApplicationInput.status < 300
        ) {
          toast.success('Saved Successfully')
          setIsLoading(false)
          getInformationDetails()
        }
      } else {
        console.error('Failed to save:', data)
        setIsLoading(false)
      }
    } catch (error) {
      console.error('Error while saving:', error)
      setIsLoading(false)
    }
  }

  const handler = () => {
    window.open(previewUrl, '_blank')
  }

  const getInformationDetails = async () => {
    try {
      const token = localStorage.getItem('auth-token')
      const url = `${process.env.REACT_APP_RESUME_PARSER_URL}/ai-chatbots/informations/${uuid}`

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.ok) {
        throw new Error('Failed to fetch bots')
      }

      const data = await response.json()

      setGetInformation(data)
    } catch (error) {
      console.error('Error fetching bots:', error)
    }
  }

  useEffect(() => {
    getInformationDetails()
  }, [])

  useEffect(() => {
    if (getInformation) {
      console.log(getInformation?.chatbot_instructions?.instructions)
      setDirective(
        getInformation?.chatbot_instructions?.instructions
          ? getInformation?.chatbot_instructions?.instructions
          : ''
      )
      setGreeting(
        getInformation?.chatbot_instructions?.greeting
          ? getInformation?.chatbot_instructions?.greeting
          : ''
      )
      setGreetingType(
        getInformation?.chatbot_instructions?.greeting_type
          ? getInformation?.chatbot_instructions?.greeting_type
          : 'static'
      )
      setAiModel(
        getInformation?.chatbot_instructions?.model
          ? getInformation?.chatbot_instructions?.model
          : 'gpt-3.5-turbo'
      )
    }
  }, [getInformation])

  useEffect(() => {
    if (data) {
      setInputJson(data?.allApplicationId?.[0]?.input?.[0])
      setId(data?.allApplicationId?.[0]?.id)
    }
  }, [data])

  useEffect(() => {
    setInputJson((prev: any) => ({
      ...prev,
      message: Greeting
    }))
  }, [Greeting])

  if (loading) return <div>Loading...</div>
  if (error) return <div>Error: {error.message}</div>

  console.log(inputJson)
  const renderContent = () => {
    switch (activeSection) {
      case 'knowledge':
        return (
          <KnowledgeSection
            getInformation={getInformation}
            getInformationDetails={getInformationDetails}
          />
        )
      case 'instructions':
      default:
        return (
          <>
            <div className='d-flex'>
              <div className='col-6'>
                <Header>
                  <HeaderTitle>Chatbot Instructions</HeaderTitle>
                  <HeaderActions>
                    {/* <ActionButton onClick={handleRestartChat}>
                  <ButtonIcon>🔄</ButtonIcon>
                  Restart Chat
                </ActionButton> */}
                    <ActionButton onClick={handler}>Preview</ActionButton>
                    <ActionButton
                      onClick={() =>
                        navigate(
                          `/ai-bots/ai-bot-builder/install-bot/${localStorage.getItem('agenticId')}`
                        )
                      }
                    >
                      Share
                    </ActionButton>
                    {/* <ActionButton>Embed</ActionButton> */}
                  </HeaderActions>
                </Header>

                <EditorSection>
                  <EditorTitle>
                    Directive
                    <Tooltip
                      title='Enter instructions that control how the AI Bot should behave, what it is allowed to answer, and how it should interact with users.'
                      placement='top'
                    >
                      <InfoIcon>ℹ️</InfoIcon>
                    </Tooltip>
                  </EditorTitle>
                  <PopoutButton>
                    <PopoutIcon>⬈</PopoutIcon>
                    Pop out
                  </PopoutButton>
                  <TextArea
                    value={Directive}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setDirective(e.target.value)}
                    rows={8}
                    placeholder='Enter chatbot directive...'
                  />

                  <EditorTitle>
                    Greeting
                    <Tooltip
                      title='Set a custom greeting or let AI generate one automatically.'
                      placement='top'
                    >
                      <InfoIcon>ℹ️</InfoIcon>
                    </Tooltip>
                  </EditorTitle>
                  <Select
                    value={greetingType}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                      setGreetingType(e.target.value)
                    }
                  >
                    <option value='static'>Static</option>
                    <option value='generated'>Generated</option>
                  </Select>
                  <TextArea
                    value={Greeting}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setGreeting(e.target.value)}
                    placeholder='Say hello and tell me what you can do.'
                    rows={4}
                  />

                  <ModelSection>
                    <ModelTitle>AI Model</ModelTitle>
                    <Select
                      value={aiModel}
                      onChange={(e: ChangeEvent<HTMLSelectElement>) => setAiModel(e.target.value)}
                    >
                      <option value='gpt-3.5-turbo'>OpenAI GPT-3.5 Turbo</option>
                      <option value='gpt4.1-mini'>OpenAI GPT-4.1 mini</option>
                      <option value='gpt4-mini'>OpenAI GPT-4o mini</option>
                    </Select>
                    <UpgradeLink href='#'>
                      Upgrade to use other models available to you in OpenAI.
                    </UpgradeLink>
                  </ModelSection>

                  <SaveButton className='btn btn-primary' onClick={handleSave} disabled={isLoading}>
                    {isLoading ? (
                      <>
                        <span
                          className='spinner-border spinner-border-sm me-2'
                          role='status'
                          aria-hidden='true'
                        ></span>
                        Saving...
                      </>
                    ) : (
                      'Save changes'
                    )}
                  </SaveButton>
                </EditorSection>
              </div>
              <div className='col-6'>
                <ChatPreviewPanel data={{ data }} />
              </div>
            </div>
          </>
        )
    }
  }

  return (
    <Container hasPreview={activeSection === 'instructions'}>
      <Sidebar>
        <SidebarSection>
          <SectionTitle>Build</SectionTitle>
          <NavItem
            active={activeSection === 'knowledge'}
            onClick={() => setActiveSection('knowledge')}
          >
            <NavIcon>🔄</NavIcon>
            Knowledge
          </NavItem>

          <NavItem
            active={activeSection === 'instructions'}
            onClick={() => setActiveSection('instructions')}
          >
            <NavIcon>✨</NavIcon>
            Instructions
          </NavItem>
          <NavItem>
            <NavIcon>⚡</NavIcon>
            Logic
          </NavItem>
          <NavItem>
            <NavIcon>🎨</NavIcon>
            Theme
          </NavItem>
          <NavItem>
            <NavIcon>🔌</NavIcon>
            Integrations
          </NavItem>
          <NavItem>
            <NavIcon>⚙️</NavIcon>
            Settings
          </NavItem>
        </SidebarSection>

        <SidebarSection>
          <SectionTitle>Review</SectionTitle>
          <NavItem>
            <NavIcon>💬</NavIcon>
            Conversations
          </NavItem>
          <NavItem>
            <NavIcon>📊</NavIcon>
            Analytics
          </NavItem>
        </SidebarSection>
      </Sidebar>

      <MainContent>{renderContent()}</MainContent>
    </Container>
  )
}

const Container = styled.div<ContainerProps>`
  --sidebar-width: ${(props) => (props.hasPreview ? '280px' : '250px')};

  display: grid;
  grid-template-columns: var(--sidebar-width) 1fr;
  min-height: 100vh;
  background-color: #f8f9fa;

  @media (max-width: 1024px) {
    --sidebar-width: 220px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    --sidebar-width: 100%;
  }
`

const Sidebar = styled.div`
  background-color: white;
  border-right: 1px solid #e9ecef;
  padding: 24px 16px;
`

const SidebarSection = styled.div`
  margin-bottom: 32px;
`

const SectionTitle = styled.h2`
  font-size: 13px;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 12px;
  padding-left: 12px;
`

const NavItem = styled.div<NavItemProps>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 2px 0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: ${(props: NavItemProps) => (props.active ? '#7c3aed' : '#495057')};
  background-color: ${(props: NavItemProps) => (props.active ? '#f3f0ff' : 'transparent')};
  &:hover {
    background-color: ${(props: NavItemProps) => (props.active ? '#f3f0ff' : '#f8f9fa')};
  }
`

const NavIcon = styled.span`
  margin-right: 12px;
  font-size: 16px;
`

const MainContent = styled.div`
  padding: 24px;
  overflow-y: auto;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

const HeaderTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
`

const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
`

const ActionButton = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid ${(props: ButtonProps) => (props.primary ? '#7c3aed' : '#e9ecef')};
  background-color: ${(props: ButtonProps) => (props.primary ? '#7c3aed' : 'white')};
  color: ${(props: ButtonProps) => (props.primary ? 'white' : '#495057')};
  font-size: 14px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`

const ButtonIcon = styled.span`
  margin-right: 8px;
`

const EditorSection = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`

const EditorTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 12px;
`

const InfoIcon = styled.span`
  margin-left: 8px;
  font-size: 14px;
  color: #6c757d;
  opacity: 0.8;
  cursor: help;
`

const PopoutButton = styled.button`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background-color: white;
  color: #495057;
  font-size: 13px;
  margin-bottom: 12px;
  cursor: pointer;
  &:hover {
    background-color: #f8f9fa;
  }
`

const PopoutIcon = styled.span`
  margin-right: 6px;
  font-size: 14px;
`

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  margin-bottom: 24px;
  resize: vertical;
  font-size: 14px;
  line-height: 1.5;
  color: #1a1a1a;
  &:focus {
    outline: none;
    border-color: #7c3aed;
  }
`

const Select = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #1a1a1a;
  background-color: white;
  cursor: pointer;
  &:focus {
    outline: none;
    border-color: #7c3aed;
  }
`

const ModelSection = styled.div`
  margin-top: 24px;
`

const ModelTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 12px;
`

const UpgradeLink = styled.a`
  color: #7c3aed;
  text-decoration: none;
  font-size: 13px;
  &:hover {
    text-decoration: underline;
  }
`

const SaveButton = styled(ActionButton)`
  width: 100%;
  justify-content: center;
  margin-top: 24px;
  background-color: #f8f9fa;
  color: #1a1a1a;
  font-weight: 500;
`

export default AiSeletectedBot
